import { render, staticRenderFns } from "./OrdersSummary.vue?vue&type=template&id=43ab6356&scoped=true"
import script from "./OrdersSummary.vue?vue&type=script&lang=js"
export * from "./OrdersSummary.vue?vue&type=script&lang=js"
import style0 from "./OrdersSummary.vue?vue&type=style&index=0&id=43ab6356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab6356",
  null
  
)

export default component.exports